import { AtlassianProductHostingTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
export var PromotionsFilters = Object.freeze({
  APPS: 'APPS',
  HOSTING: 'HOSTING',
  ACTIVE: 'ACTIVE'
});